// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Internal Dependencies
import FoodReviewORGenericHighlight from './FoodReviewORGeneric';

const FoodReview = (props) => (
  <FoodReviewORGenericHighlight
    heading="Food Review"
    selectedPage={props.selectedPage}
    isGeneric={false}
  />
);

FoodReview.propTypes = {
  selectedPage: PropTypes.shape({
    id:        PropTypes.number,
    staffType: PropTypes.string,
    name:      PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  selectedPage: state.page.selected,
});

export default connect(mapStateToProps, null)(FoodReview);
